<template src="./HeaderComponent.html"></template>
<script>
import BreadcrumbComponent from '@/components/breadcrumb/BreadcrumbComponent.vue'
import IconUserDefault from "@/components/icons/IconUserDefault.vue";
import CommonService from "@/services/common.service.ts";
import IconCaretDown from "@/components/icons/IconCaretDown.vue";
import {useAccountStore} from "@/stores/account.js";
import {useRouter} from "vue-router";
import {AppConstant} from "@/supports/app.constant.ts";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "@/stores/store.js";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";

export default {
  name: 'HeaderComponent',
  components: {SelectNormal, IconCaretDown, IconUserDefault, BreadcrumbComponent },
  setup() {
    const username = CommonService.getUserName()
    const isActive = ref(false)
    const isStoreActive = ref(false)
    const usingStoreName = ref('')
    const accountStore = useAccountStore()
    const storesList = ref([])
    const router = useRouter()
    const storeCompStore = useStore()
    onMounted(() => {
      getListStores()
    })

    watch(() => storeCompStore.stores, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          storesList.value.push({
            name: item.name,
            value: item.id
          })
        })
      }
      if(!storeCompStore.usingStore) {
        usingStoreName.value = storesList.value[0].name
      }
    });

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    function selectStore(store) {
      if(storeCompStore.usingStore.id !== store.id) {
        storeCompStore.usingStore = store;
        usingStoreName.value = store.name;
      }
    }

    function showListStoreHeader() {
      isStoreActive.value = !isStoreActive.value
    }
    function showMenuUser() {
      isActive.value = !isActive.value
    }
    async function logout() {
      const params = {}
      const url = AppConstant.URL_API_LOCAL + 'api/v1/auth/logout';
      await accountStore.logout(url, params)
      CommonService.clearTokenAuth();
      await router.push('/login')
    }

    return {
      username,
      isActive,
      isStoreActive,
      storesList,
      usingStoreName,
      logout,
      showMenuUser,
      showListStoreHeader,
      selectStore,
      CommonService
    }
  },
}
</script>
<style lang="scss">
.header-wrapper {
  position: fixed;
  padding: 18px 20px;
  transition: .5s;
  background-color: #fff;
  box-shadow: 0 4px 40px rgba(39,32,120,.1);
  width: 100%;
  z-index: 8;
  .nav-menus {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0;
    li {
      padding: 6px 10px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      &.user {
        position: relative;
        .user-avatar {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: 1px solid;
          padding: 5px;
          svg {
            width: 100%;
          }
        }
        .arrow-menu {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
        .user-menu {
          position: absolute;
          top: 40px;
          left: -10px;
          width: 150px;
          padding: 2px;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
          z-index: 10;
          background: #ffffff;
          cursor: pointer;
          li {
            text-align: center;
          }
        }
      }
      &.warehouse-header {
        position: relative;
        .arrow-menu {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
        .warehouse-list-header {
          position: absolute;
          top: 40px;
          left: -10px;
          width: 150px;
          padding: 2px;
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
          z-index: 10;
          background: #ffffff;
          cursor: pointer;
          li {
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
